import { render, staticRenderFns } from "./vipLook.vue?vue&type=template&id=b15dfc12&scoped=true"
import script from "./vipLook.vue?vue&type=script&lang=js"
export * from "./vipLook.vue?vue&type=script&lang=js"
import style0 from "./vipLook.vue?vue&type=style&index=0&id=b15dfc12&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15dfc12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b15dfc12')) {
      api.createRecord('b15dfc12', component.options)
    } else {
      api.reload('b15dfc12', component.options)
    }
    module.hot.accept("./vipLook.vue?vue&type=template&id=b15dfc12&scoped=true", function () {
      api.rerender('b15dfc12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketingManage/vipManage/vipLook.vue"
export default component.exports